<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="amber darken-1">
                <v-toolbar-title>MundoMaker</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-alert type="error" :value="hasError">{{ response }}</v-alert>
              <v-card-text>
                <v-form @submit="checkCreds()" >
                  <v-text-field
                    prepend-icon="person"
                    name="login"
                    label="Login"
                    placeholder="Login"
                    type="text"
                    v-model="username"
                  ></v-text-field>
                  <v-text-field
                    prepend-icon="lock"
                    name="password"
                    label="Senha"
                    placeholder="Senha"
                    id="password"
                    type="password"
                    @keyup.enter.native="checkCreds()"
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
              <p><a @click.prevent="recoverPassword">Esqueceu a senha?</a></p>
                <v-spacer></v-spacer>
                <v-btn color="orange darken-1" :carregar="animation" dark @click="checkCreds()">
                  <v-progress-circular indeterminate color="primary" v-if="carregar"></v-progress-circular>
                  <span v-else>Login</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import api from '../../api';

export default {
  name: 'Login',
  data (router) {
    return {
      section: 'Login',
      hasFocus: false,
      autofilled: false,
      show: true,
      loading: '',
      username: '',
      password: '',
      response: '',
      responsepositive: '',
      hasError: false,
      animation: false,
      carregar: false
    };
  },
  components: {},
  mounted () {
    this.$watch('username', () => {
    })
  },
  methods: {
    recoverPassword () {
      if (this.username === '') {
        this.response = 'Insira o nome de usuário';
        this.hasError = true;
      } else {
        var self = this;
        var payload = { username: this.username };
        api
          .request('post', 'recover-password/', payload, 'login')
          .then(resp => {
            if (resp.status === 500) {
              console.log('sttu', resp.status)
              self.response = 'Email de recuperação enviado';
              self.responsepositive = 'Email de recuperação enviado';
            }
          });
      }
    },
    checkCreds () {
      const { username, password } = this;
      this.carregar = true;
      this.response = '';

      /* Making API call to authenticate a user */
      api
        .request('post', 'api-token-auth/', { username, password }, 'login')
        .then(response => {
          var data = response.data
          console.log(data)
          /* Checking if error object was returned from the server */
          if (response.response) {
            var status = response.response.status;
            if (status === 400) {
              this.response = 'Informações incorretas';
              this.hasError = true;
            } else {
              this.response =
                'Servidor parece estar offline, tente novamente mais tarde';
              this.hasError = true;
              this.carregar = false;
            }

            return;
          }

          /* Setting user in the state and caching record to the localStorage */
          if (data.token) {
            this.carregar = false;
            var token = 'Token ' + data.token;
            this.$store.commit('SET_USER', data.user);
            this.$store.commit('SET_TOKEN', token);
            this.$store.commit('SET_COMPANY', {
              id: data.company_id,
              name: data.company_name,
              makerlab: data.makerlab
            });
            this.carregar = false;
            // this.$router.push(this.$route.query.redirect);
            this.$router.push('/')
          }
        })
        .catch(err => {
          console.log(err);
          this.carregar = false;
        });
    },
    toggleLoading () {
      this.loading = this.loading === '' ? 'loading' : '';
    },
    resetResponse () {
      this.response = '';
    }
  }
};
</script>

<style>
html,
body,
.container-table {
  height: 100%;
  background-color: #00c7f4 !important;
}
a {
  color: black;
}
.forgot-password {
  margin-top: 20px;
}

.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.logo {
  width: 40em;
  padding: 0;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
}
.input-group input {
  height: 4em;
}
.alert {
  margin-top: 0;
}   

   .form-group {
       position: relative;
   }
   .form-group label {
       position: absolute;
       top: 10px;
       left: 12px;
       pointer-events: none;
       color: #888888;
   }
   .form-group .form-control {
       height: 45px;
   }
   .form-group.has-focus label {
       color: #009fff;
   }
   .form-group.has-focus label,
   .form-group.has-value label {
       font-size: 12px;
       top: 3px;
   }
   .form-group.has-focus .form-control,
   .form-group.has-value .form-control {
       padding-top: 20px;
   }
   :-webkit-autofill {
       animation-name: onAutoFillStart;
   }
   :not(:-webkit-autofill) {
       animation-name: onAutoFillCancel;
   }
   @keyframes onAutoFillStart {
       from {
       }
       to {
       }
   }
   @keyframes onAutoFillCancel {
       from {
       }
       to {
       }
   }
</style>



// WEBPACK FOOTER //
// src/components/pages/Login.vue